import request from "@/utils/request";

/*
地图模式 : 告警信息列表（最新10条）
*/
export const getAlarmData = () => {
  return request.get("/rest/screen/yunwei/alarm/list");
};

/*
地图模式 : 弹框详情数据(状态监测,图例模式)
* @param { integer } terminalId - 终端id ( required: true )
*/
export const statusDetail = terminalId => {
  return request.get("/rest/screen/yunwei/statusDetail", {
    terminalId
  });
};

/*
地图模式 : 次数统计
*/
export const summary = () => {
  return request.get("/rest/screen/yunwei/summary");
};

/*
地图模式 : 站点信息
*/
export const getTerminalData = name => {
  let params = name && name !== '全部' ? { province: name } : {};
  return request.get("/rest/screen/yunwei/terminals", params);
};

/*
地图模式 : 获取区域
*/
export const getRegions = () => {
  return request.get("/rest/screen/yunwei/regions");
};
